'use client';

import { IRepository, IUser } from '@/types';
import FileUploadForm, { TFileUploadFormCompleteData } from '@/components/Repository/FileUploadForm';

const FileUploader: React.FC<{
  user: IUser;
  repository: IRepository;
}> = ({ user, repository }) => {
  const onFileUploadComplete = ({ repository, branch, fileNames, targetDirectory }: TFileUploadFormCompleteData) => {
    const filePath = [targetDirectory, fileNames[0]].join('/');
    window.location.href = `/${repository.namespace}/${repository.name}/evaluations/new?path=${filePath}`;
  };

  return <FileUploadForm user={user} repository={repository} maxFiles={1} onComplete={onFileUploadComplete} />;
};

export default FileUploader;
